import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`João is a Strategic Software Delivery Consultant at Xebia. He focuses on
helping teams and organizations to make strategic decisions regarding
the software; aligning teams and software to optimize the stream-based
value. He believes in the power of collaboration and is a fan of visual
collaboration tools.`}</p>
    <p>{`When he is not on his duties, you can find
him travelling with his daughter and wife, or laying down on the beach
reading a book. João is an amateur cook in his remaining time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      